<script>
	import UISection from "../ui/UISection.svelte";
	import UISlider from "../ui/UISlider.svelte";
	import UIList from "../ui/UIList.svelte";
	import UIListItem from "../ui/UIListItem.svelte";
	import UIButton from "../ui/UIButton.svelte";
	import UIContact from "../ui/UIContact.svelte";
	import router from "../stores/router";
	import base from "../stores/base";
	router.track();

	const API = process.env.APP_API;
	let item = null;
	let latestItems = [];

	fetch(API + "/home/detail")
		.then((res) => {
			return res.json();
		})
		.then((json) => {
			if (json.message) {
				console.log("----", json.message);
			} else {
				item = json;
			}
		})
		.catch((e) => {
			console.log("----error", e);
		});

	fetch(API + "/items/index/latest")
		.then((res) => {
			return res.json();
		})
		.then((json) => {
			if (json.message) {
				console.log("----", json.message);
			} else {
				latestItems = json;
			}
		})
		.catch((e) => {
			console.log("----error", e);
		});

	$: {
		console.log("item", item);
	}
</script>

<main class="PageHome">
	{#if item}
		<UISlider items={item.slides.map(([type, data]) => data)} />

		<UISection gray center paddingtop="3em" paddingbottom="5em">
			<h3 class="PageHome-heading">
				{{ ja: "最新記事", en: "Latest Post" }[$base.lang]}
			</h3>
			<UIList>
				{#each latestItems as data}
					<UIListItem {data} />
				{/each}
			</UIList>

			<UIButton icon="right" on:click={() => router.push("/news")}
				>{{ ja: "もっと見る", en: "See More" }[$base.lang]}</UIButton
			>
			<!-- 「すべての記事」がある場合 -->
			<!-- <UIButton icon="right" on:click={() => router.push("/all")}
				>{{ ja: "もっと見る", en: "More.." }[$base.lang]}</UIButton
			> -->
		</UISection>

		<section class="PageHome-about">
			<div
				class="PageHome-about-img"
				style="background-image:url({item.aboutImage})"
			/>
			<div class="PageHome-about-info">
				<h3>{@html item["aboutTitle_" + $base.lang]}</h3>
				<p>
					{@html item["aboutDescription_" + $base.lang]
						.split("\n")
						.join("<br>")}
				</p>
				<div class="PageHome-about-info-btn">
					<UIButton
						icon="right"
						on:click={() => router.push("/about")}
						>{{ ja: "詳しく見る", en: "Details" }[
							$base.lang
						]}</UIButton
					>
				</div>
			</div>
		</section>

		<div class="PageHome-menu-area">
			<UISection gray paddingtop="4em" paddingbottom="4em">
				<nav class="PageHome-menu">
					<div class="PageHome-menu-item">
						<div class="PageHome-menu-item-box">
							<div
								class="PageHome-menu-item-img"
								style="background-image:url({item.reportImage})"
							/>
							<div class="PageHome-menu-item-text">
								<div class="PageHome-menu-item-title">
									{item["reportTitle_" + $base.lang]}
								</div>
								<div class="PageHome-menu-item-desc">
									{@html item[
										"reportDescription_" + $base.lang
									]
										.split("\n")
										.join("<br>")}
								</div>
								<UIButton
									home
									icon="right"
									on:click={() => router.push("/activity")}
									>{{ ja: "もっと見る", en: "See More" }[
										$base.lang
									]}</UIButton
								>
							</div>
						</div>
					</div>
					<div class="PageHome-menu-item">
						<div class="PageHome-menu-item-box">
							<div
								class="PageHome-menu-item-img"
								style="background-image:url({item.researchImage})"
							/>
							<div class="PageHome-menu-item-text">
								<div class="PageHome-menu-item-title">
									{item["researchTitle_" + $base.lang]}
								</div>
								<div class="PageHome-menu-item-desc">
									{@html item[
										"researchDescription_" + $base.lang
									]
										.split("\n")
										.join("<br>")}
								</div>
								<UIButton
									home
									icon="right"
									on:click={() => router.push("/research")}
									>{{ ja: "もっと見る", en: "See More" }[
										$base.lang
									]}</UIButton
								>
							</div>
						</div>
					</div>
					<div class="PageHome-menu-item">
						<div class="PageHome-menu-item-box">
							<div
								class="PageHome-menu-item-img"
								style="background-image:url({item.movieImage})"
							/>
							<div class="PageHome-menu-item-text">
								<div class="PageHome-menu-item-title">
									{item["movieTitle_" + $base.lang]}
								</div>
								<div class="PageHome-menu-item-desc">
									{@html item[
										"movieDescription_" + $base.lang
									]
										.split("\n")
										.join("<br>")}
								</div>
								<UIButton
									home
									icon="right"
									on:click={() => router.push("/movie")}
									>{{ ja: "もっと見る", en: "See More" }[
										$base.lang
									]}</UIButton
								>
							</div>
						</div>
					</div>
				</nav>
			</UISection>
		</div>
		<UISection>
			<UIContact
				title={item["contactTitle_" + $base.lang]}
				body={item["contactDescription_" + $base.lang]}
			/>
		</UISection>
	{/if}
</main>

<style global>
	.PageHome-heading {
		font-weight: bold;
		font-size: 2.1em;
		color: #61788c;
		letter-spacing: 0.05em;
		display: flex;
		align-items: center;
		width: 100%;
		margin: 0 auto;
		padding-bottom: 1em;
	}
	.pc .PageHome-heading {
		font-size: 2em;
		width: 50%;
		padding-bottom: 0;
	}
	.PageHome-heading:before,
	.PageHome-heading:after {
		content: "";
		height: 2px;
		flex-grow: 1;
		border-top: 2px dashed #61788c;
	}
	.PageHome-heading:before {
		margin-right: 1em;
	}
	.PageHome-heading:after {
		margin-left: 1em;
	}

	.PageHome-about {
		display: flex;
		position: relative;
		flex-direction: column;
	}
	.pc .PageHome-about {
		align-items: center;
		flex-direction: row;
	}

	.PageHome-about-img {
		flex: 0 0 100%;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		height: 100%;
		min-height: 240px;
	}

	.PageHome-about-info {
		flex: 0 0 100%;
		max-width: 880px;
		padding: 2.5em;
		text-align: center;
	}

	.pc .PageHome-about-info {
		flex: 0 0 60%;
		padding: 4em 1em 3em 4.8em;
		text-align: left;
	}
	.pc .PageHome-about-img {
		flex: 0 0 40%;
		min-height: 512px;
	}
	@media screen and (min-width: 1121px) and (max-width: 1360px) {
		.pc .PageHome-about-img {
			min-height: 620px;
		}
	}
	@media screen and (min-width: 921px) and (max-width: 1120px) {
		.pc .PageHome-about-info {
			flex: 0 0 61%;
			max-width: 880px;
			padding: 4em 1em 3em 2em;
		}
		.pc .PageHome-about-img {
			flex: 0 0 39%;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			height: 100%;
			min-height: 620px;
		}
	}
	@media screen and (min-width: 480px) and (max-width: 920px) {
		.PageHome-about-img {
			flex: 0 0 39%;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			height: 100%;
			min-height: 360px;
		}
	}

	.PageHome-about-info h3 {
		color: #61788c;
		font-size: 2.4em;
		font-weight: bold;
		line-height: 1.4em;
	}
	.pc .PageHome-about-info h3 {
		color: #61788c;
		font-size: 3.125em;
		font-weight: bold;
		line-height: 1.4em;
	}
	.PageHome-about-info h3 ruby rt {
		font-size: 0.42em;
		transform: translateY(-0.3em);
		line-height: 2em;
		text-align: center;
	}

	.PageHome-about-info h3 span {
		font-size: 0.72em;
	}
	.PageHome-about-info p {
		font-size: 1.06em;
		padding: 1.5em 0;
	}
	.pc .PageHome-about-info p {
		font-size: 1.375em;
		padding: 2.7em 0 1.6em;
	}

	.PageHome-about-info-btn {
		text-align: center;
	}
	.pc .PageHome-about-info-btn {
		text-align: right;
	}

	.PageHome-menu-area {
		position: relative;
	}

	.PageHome-menu-area:before {
		content: "";
		position: absolute;
		right: 0;
		top: 0;
		left: 0;
		width: 0;
		height: 0;
		margin: auto;
		border-style: solid;
		border-color: #fff transparent transparent transparent;
		border-width: 40px 50px 0 50px;
		z-index: 3;
	}
	.pc .PageHome-menu-area:before {
		border-width: 50px 90px 0 90px;
	}

	.PageHome-menu {
		display: flex;
		margin: 0;
		flex-wrap: wrap;
	}
	.pc .PageHome-menu {
		flex-direction: row;
		margin: 0 -1em;
	}

	.PageHome-menu-item {
		padding: 1em;
		width: 100%;
	}
	@media screen and (min-width: 701px) {
		.PageHome-menu-item {
			padding: 0.5em 0.25em;
			width: 50%;
		}
	}
	@media screen and (min-width: 960px) {
		.PageHome-menu-item {
			padding: 1em;
			width: 33.3%;
		}
	}

	.PageHome-menu-item-box {
		background: #fff;
		height: auto;
	}

	.PageHome-menu-item-img {
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		height: 200px;
	}
	.PageHome-menu-item-text {
		text-align: center;
		padding: 2.5em 1em;
	}
	.PageHome-menu-item-title {
		font-size: 2.125em;
		font-weight: bold;
		line-height: 1;
	}

	.PageHome-menu-item-desc {
		padding: 1.1em 0;
		font-size: 1.25em;
	}
	.pc .PageHome-menu-item-desc {
		padding: 1.5em 0 2em;
	}
	@media screen and (min-width: 801px) and (max-width: 1121px) {
		.pc .PageHome-menu-item-title {
			font-size: 1.8em;
		}
		.pc .PageHome-menu-item-desc {
			padding: 1.5em 0 2em;
			font-size: 0.9em;
		}
	}
</style>
